import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[goAnchor]',
	standalone: false
})
export class GoAnchorDirective {
	constructor (
		public viewContainerRef: ViewContainerRef
	) {
	}
}
